import React from 'react';
import { Button } from './ui/Button';
import { FileText, Clock, Calendar, CheckCircle2, Package } from 'lucide-react';
const CHECKOUT_URL = 'https://www.compradigitalya.com/checkouts/cn/hWNBfCDdHQUTNK8tIikCUts2/es-ar?_r=AQAB1bvEcqlGPcyGyamgvjBgxYvtyuUNQZ9h35zPIFBVk78&cart_link_id=nZEWN4Xd&preview_theme_id=141062045767';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 md:pt-24 md:pb-16 max-w-4xl mx-auto text-center" data-id="element-125">
      <div className="inline-block bg-surface2 border border-primary/30 rounded-full px-3 py-1 text-xs md:text-sm font-medium text-primary mb-3 md:mb-6" data-id="element-126">
        🇦🇷 El sistema N°1 para profes de E. Funcional en Argentina
      </div>

      {/* TITLE — above mockup */}
      <h1 className="text-2xl md:text-6xl font-extrabold leading-tight mb-4 md:mb-6" data-id="element-127">
        Todo tu año de Entrenamiento Funcional.
        <br data-id="element-128" />
        <span className="text-primary" data-id="element-129">Listo. Desde hoy.</span>
      </h1>

      {/* MOCKUP — centered, clickable to scroll to pricing */}
      <a href="#pricing" className="my-4 md:my-8 flex justify-center group" aria-label="Ver oferta del Combo Completo" data-id="element-130">
        <img src="https://cdn.magicpatterns.com/uploads/2ymYcyVeknqTD4GdDGYRQy/combo_completo_e.funcional_2_sin_fondo.png" alt="Combo Completo de Entrenamiento Funcional — 6 Tomos + Bonos" className="w-[70%] max-w-[560px] md:w-full aspect-square object-contain drop-shadow-[0_0_40px_rgba(74,222,128,0.25)] transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-131" />
      </a>

      {/* SUBTITLE — below mockup */}
      <p className="text-base md:text-2xl text-white mb-3 md:mb-4 max-w-2xl mx-auto font-bold" data-id="element-132">
        COMBO COMPLETO DE E. FUNCIONAL — 6 Tomos + 6 Bonos
      </p>

      <p className="text-xs md:text-lg text-zinc-300 mb-4 md:mb-10 max-w-3xl mx-auto" data-id="element-133">
        240 clases listas · Progresión anual · Sin planificar · Sin improvisar
      </p>

      <div className="flex flex-wrap justify-center gap-2 md:gap-6 mb-4 md:mb-10 text-xs md:text-base text-zinc-300" data-id="element-134">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-135">
          <FileText className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-136" /> 100% PDF
        </div>
        <div className="flex items-center gap-1 md:gap-2" data-id="element-137">
          <Clock className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-138" /> Acceso en 5
          min
        </div>
        <div className="flex items-center gap-1 md:gap-2" data-id="element-139">
          <Calendar className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-140" /> 48 semanas
        </div>
        <div className="flex items-center gap-1 md:gap-2" data-id="element-141">
          <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-142" /> 240
          clases
        </div>
        <div className="flex items-center gap-1 md:gap-2" data-id="element-143">
          <Package className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-144" /> 6 Tomos + 6
          Bonos
        </div>
      </div>

      <Button href={CHECKOUT_URL} className="text-base md:text-2xl py-3 md:py-5 px-6 md:px-8 w-full md:w-auto mb-4 md:mb-6" data-id="element-145">
        🏋️ QUIERO MI COMBO COMPLETO AHORA
      </Button>

      <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-zinc-400 font-medium" data-id="element-146">
        <span className="flex items-center gap-1" data-id="element-147">🛡️ Garantía 7 días</span>
        <span className="hidden md:inline text-zinc-700" data-id="element-148">|</span>
        <span className="flex items-center gap-1" data-id="element-149">🔒 Pago seguro</span>
        <span className="hidden md:inline text-zinc-700" data-id="element-150">|</span>
        <span className="flex items-center gap-1" data-id="element-151">💳 Mercado Pago</span>
      </div>
    </section>;
}